import { render, staticRenderFns } from "./RankingSetNew.vue?vue&type=template&id=5f0c4d3d"
import script from "./RankingSetNew.vue?vue&type=script&lang=js"
export * from "./RankingSetNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports